import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-new-tab-button',
  templateUrl: './new-tab-button.component.html',
  styleUrls: ['./new-tab-button.component.scss']
})
export class NewTabButtonComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

  openInNewTab(): void {
    window.open(window.location.href, '_blank');
  }
}
